// combine
import combineReducer from './combineReducer';

// reducer
import userReducer from '../reducers/userReducer';
import testReducer from '../reducers/testReducer';
import mapReducer from '../reducers/mapReducer';
import timelineReducer from '../reducers/timelineReducer';
import snaReducer from '../reducers/snaReducer';

// all in one
const reducers = combineReducer({
	user: userReducer,
	test: testReducer,
	map: mapReducer,
	timeline: timelineReducer,
	sna: snaReducer,
});

export default reducers;
